import React, { useState, useEffect } from "react";
import { DynamoDBClient, ScanCommand } from "@aws-sdk/client-dynamodb";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import awsmobile from "../aws-exports";

function Test() {
  const [guestData, setGuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize DynamoDB Client with Guest Access
  const dynamoDBClient = new DynamoDBClient({
    region: awsmobile.aws_project_region,
    credentials: fromCognitoIdentityPool({
      clientConfig: { region: awsmobile.aws_project_region },
      identityPoolId: awsmobile.aws_cognito_identity_pool_id,
    }),
  });

  useEffect(() => {
    const testGuestAccess = async () => {
      setLoading(true);
      try {
        const command = new ScanCommand({ TableName: "users-dev" });
        const data = await dynamoDBClient.send(command);
        console.log("Guest User Data:", data);
        setGuestData(data.Items || []);
      } catch (err) {
        console.error("Guest User Error:", err);
        setError(err.message || "Unauthorized access.");
      } finally {
        setLoading(false);
      }
    };

    testGuestAccess();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ paddingTop: "50px", textAlign: "center" }}>
      <h2 style={{ marginBottom: "20px", marginTop: "20px" }}>Guest Access Test</h2>
      {loading ? (
        <p>Attempting guest access...</p>
      ) : error ? (
        <p style={{ color: "red" }}>Error: {error}</p>
      ) : (
        <pre style={{ textAlign: "left", maxWidth: "600px", margin: "auto", whiteSpace: "pre-wrap" }}>
          {guestData.length > 0 ? JSON.stringify(guestData, null, 2) : "No data retrieved (access might be restricted)."}
        </pre>
      )}
    </div>
  );
}

export default Test;
